<script setup lang="ts">
import BaseIcon from '@c/common/Icon.vue';
import { envOrigin } from '@/config/setup';
import { isApp, openNativeBrowser } from '@/utils/appBridge';
import useLoginInvite from '@/hook/useLoginInvite';
import { GlossaryTerm } from '../types';
// 定义组件属性
const props = defineProps<{
    // 是否为移动端
    isM?: boolean
    term: GlossaryTerm | null
}>();

const { t, locale } = useI18n();

var {
  copy
} = useLoginInvite();

const url = computed(() => {
  const { term } = props;
  return `${envOrigin}/${locale.value}${term?.link}`;
});

const text = computed(() => {
  const { term } = props;
  return `${t('glossary.term_title', { title: term?.title })} / ${term?.subtitle}`;
});

const methods = {
  goTwitter() {
    const twitterUrl = `https://twitter.com/intent/tweet?text=${text.value}&url=${url.value}`;
    if (isApp) {
      openNativeBrowser(twitterUrl);
    } else {
      window.open(twitterUrl);
    }
  },
  goWhatsapp() {
    const whatsappUrl = `https://api.whatsapp.com/send?text=${`${text.value} / ${url.value}`}`;
    if (isApp) {
      openNativeBrowser(whatsappUrl);
    } else {
      window.open(whatsappUrl);
    }
  },
  goTelegram() {
    const telegramUrl = `https://t.me/share/url?text=${text.value}&url=${url.value}`;
    if (isApp) {
      openNativeBrowser(telegramUrl);
    } else {
      window.open(telegramUrl);
    }
  }
};
</script>

<template>
  <div
    class="flex items-center gap-x-24px"
  >
    <a class="item" @click="methods.goTwitter">
      <BaseIcon name="twitter" class="text-lg-m" />
    </a>
    <a class="item" @click="methods.goWhatsapp">
      <BaseIcon name="whatsapp" class="text-display-xs-m" />
    </a>
    <a class="item" @click="methods.goTelegram">
      <BaseIcon name="telegram" class="text-display-xs-m" />
    </a>
    <a class="item" @click="copy(`${text} ${url}`, 'text')">
      <BaseIcon name="copy" class="text-sm-m"/>
    </a>
  </div>
</template>

<style scoped lang="scss">
.item {
  @apply w-24px h-24px rd-8px inline-flex items-center justify-center bg-[--gray-400] c-white;
}
</style>
